import axios, { AxiosResponse } from "axios";
import { User } from "../interfaces/user";

const BASIC_API_URL = "/api";


/*export const getUser = async () => {
  try {
    const response = await axios.get(`${BASIC_API_URL}/admin`);
    return response;
  } catch (error) {
    console.log(process.env.BASIC_API_URL);
    throw new Error(`${error.response.data.error}`);
  }
};*/

export const getUserByComp = async (groupId) => {
  try {
    const response = await axios.get(
      `${BASIC_API_URL}/user/userComp/${groupId}`
    );
    return response;
  } catch (error) {
    throw new Error(`${error.response.data.error}`);
  }
};

export const newAdmin = async (adminData) => {
  try {
    const response = await axios.post(
      `${BASIC_API_URL}/admin/newAdmin`,
      adminData
    );
    return response.data;
  } catch (error) {
    throw new Error("Erreur lors de l'ajout de l'entreprise");
  }
};

/*interface UserResponse {
  status: number;
  message?: string;
  user?: User;
}*/

export const loginUser = async (
  email: string,
  password: string
) => {
  try {
    const response: AxiosResponse<any> = await axios.post(
      `${BASIC_API_URL}/user/login`,
      { email, password },
      { withCredentials: true }
    );
    return {
      status: response.status,
      res: response,
    };
  } catch (error: any) {
    console.log("loginUser error", error);
    // keep original Axios error so saga can inspect response
    // still log response details for debugging
    if (error?.response) {
      console.log("loginUser response status", error.response.status);
      console.log("loginUser response headers", error.response.headers);
      console.log("loginUser response data", error.response.data);
    }
    throw error;
  }
};

export const headsetLogin = async (
  email: string,
  password: string,
) => {
  try {
    const response: AxiosResponse<any> = await axios.post(
      `${BASIC_API_URL}/user/login`,
      { email, password },
      { withCredentials: true }
    );
    /*const loginData = { email: email,
      token: response.data.accessToken,
    };*/

    return {
      status: response.status,
      res: response,
      //accessToken: response.data.accessToken,
    };
  } catch (error: any) {
    console.log(error);
    throw new Error(`${error}`);
  }
};

export const registerUser = async (userData) => {
  console.log(userData);
  try {
    const response = await axios.post(`${BASIC_API_URL}/user/register`, userData);
    return response.data;
  } catch (error) {
    console.error("Erreur lors de l'ajout de l'entreprise :", error);
    throw new Error("Erreur lors de l'ajout de l'entreprise");
  }
}


//Creators : Florian Cohen-Joly / Thomas Castanier @3DDGAMES -- Under license